
import { client } from '../../../../../common-utils/libraries/axios/axios';
import CONNECTION from '../apiUrls';

const mutationPostLogin = (onSuccess, onError) => {
    return {
        mutationFn: (userLogs) => {
            return client.post(CONNECTION.LOGIN.url, userLogs);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationPostLogin;